import { connect } from 'react-redux';

import { get } from 'dpl/shared/utils/object';
import {
  findIdxInManyToManyAssociationArray,
  getValuesOfManyToManyAssociationArray
} from 'dpl/shared/form/utils';

import { removeAllManyToManyAssociations } from '../utils';

export default function withApplicationPreferences(inputName) {
  return connect(
    (
      _,
      {
        formState,
        handleNextClick,
        addToFormState,
        pushToFormState,
        removeFromFormState
      }
    ) => ({
      inputName,
      selectedPreferences: getValuesOfManyToManyAssociationArray(
        get(formState, inputName, []),
        ['breeder_waitlist_preference_id']
      ).filter(Boolean),
      onPreferenceClick: bwpId => {
        const idx = findIdxInManyToManyAssociationArray(
          get(formState, inputName, []),
          bwpId,
          ['breeder_waitlist_preference_id']
        );

        if (idx >= 0) {
          removeFromFormState(`${inputName}.${idx}`);
          return;
        }

        pushToFormState(inputName, {
          breeder_waitlist_preference_id: bwpId
        });
      },
      onNoPreferenceClick: () => {
        const currentState = get(formState, inputName, []);
        const updatedState = removeAllManyToManyAssociations(currentState);

        addToFormState(inputName, updatedState, handleNextClick);
      }
    })
  );
}
